import Menu from 'models/menu';
import MenuView from 'views/menu/menu-view';
import ContentService from 'services/loader-handler-services/content-service';
import CourseSettingsService from 'services/course-handler-services/course-settings-service';
import MenuService from 'services/course-handler-services/menu-service';
import { SessionStorageService } from 'services/data-handler-services/web-storage-service';
import utils from 'lib/utils';
import Controller from './base/controller';
import _ from 'lodash';
import EF from 'ef/ef';

export default Controller.extend({
  show: function (params, route, options) {
    SessionStorageService.setItem('queryParams', options.query);
    const defaults = {
      homePage: 'home',
      type: 'module', //module menu
      groups: false, // forces order at the group level.
    };
    const menuSettings = CourseSettingsService.get('menu');
    _.defaults(menuSettings, defaults);

    if (options.query.group) {
      MenuService.currentGroup = EF.groups.find({
        id: parseInt(options.query.group),
      });
    } else {
      MenuService.currentGroup = null;
    }

    const page = params.page || menuSettings.homePage;
    const onHomePage = page === menuSettings.homePage;

    if (CourseSettingsService.get('menuOverride') && onHomePage) {
      const menuOverride = CourseSettingsService.get('menuOverride');
      if (menuOverride && menuOverride.postMessage) {
        window.postMessage({ event_type: menuOverride.postMessage }, window.location.origin);
      } else {
        window.location = menuOverride;
      }
      return;
    }

    const menu = new Menu(menuSettings);
    if (onHomePage) {
      menu.set('dialog', true);
    }
    if (menu.get('skip')) {
      const firstIncomplete = EF.modules.getFirstAvailable(menuSettings);
      if (!firstIncomplete && EF.module === EF.modules.last()) {
        window.postMessage({ event_type: 'close-content' }, window.location.origin);
      } else {
        utils.redirectToModule(firstIncomplete);
      }
    } else {
      menu.set('key', page);

      ContentService.applyContentAndLocale(menu, `menu.${page}`).then(() => {
        ContentService.addForgePathsToPage(menu, `.menu.${page}`);
        if (menu.get('groups') && !EF.enrollment.get('demoMode')) {
          EF.groups.lockGroups(menu.get('lockPastGroups'), MenuService.getUnlockDay());
        }
        MenuService.autoPlay();
        if (Object.isExtensible(this)) {
          this.view = new MenuView({
            className: `menu ${page}`,
            model: menu,
            region: 'main',
          });
        } else {
          return;
        }
      });
    }
  },
});
